<template>
  <AbaDownload :titulo="titulo" v-if="!loading">
    <div slot="subtitulo">
      <span class="segunda-cor-fonte"> Filtros aplicados: </span>
      {{ textoSubtitulo }}
    </div>
    <div style="width: 100%; text-align: center" v-if="!ocorreuErro">
      <div class="container-vertical">
        <CardVerticalDownload unico :titulo="objetoArquivo.nomeArquivo" />
      </div>

      <unicom-botao @click="baixar" nomeIcone="download-cloud" :largura="360">
        BAIXAR
      </unicom-botao>
    </div>
    <div class="titulo negrito my-auto" v-else>NENHUM ARQUIVO ENCONTRADO</div>
  </AbaDownload>
  <unicom-spinner
    v-else
    style="
      min-height: 450px;
      display: flex;
      flex-flow: wrap column;
      justify-content: center;
    "
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
    mensagem="Carregando..."
  />
</template>

<script>
import AbasMixin from "../AbasMixin";
import AbaDownloadMixin from "../AbaDownloadMixin";

export default {
  mixins: [AbasMixin, AbaDownloadMixin],
  data() {
    let objetoArquivo = {};

    return {
      loading: false,
      objetoArquivo,
      ocorreuErro: false
    };
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      this.inicializarArquivo();
    },
    inicializarArquivo() {
      this.loading = true;
      this.sleep(250).finally(() => {
        this.getArquivoRedimensionamentoHospitalar(this.filtroComputed)
          .then(res => {
            const { nomeArquivo } = res.data;

            this.objetoArquivo = { nomeArquivo };
          })
          .catch(() => {
            this.ocorreuErro = true;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    baixar() {
      this.$store.commit("setLoadingModal", true);

      this.getDownloadRedimensionamentoHospitalar(this.filtroComputed)
        .then(res => {
          if (res.status === 204) return;
          this.$helpers.baixarArquivo(
            res.data,
            res.headers["content-disposition"]
          );
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    }
  },
  computed: {
    filtroComputed() {
      if (!this.objetoFiltro) {
        return {
          chavePrestador: "EXCLUIDO"
        };
      } else {
        const { competencia } = this.objetoFiltro;
        let filtro = { chavePrestador: "EXCLUIDO" };

        if (competencia) {
          filtro.competencia = competencia;
        }

        return filtro;
      }
    },
    textoSubtitulo() {
      if (!this.objetoFiltro) return;

      const { descricaoPrestador, competencia } = this.objetoFiltro;

      if (!competencia) {
        return `${this.letraMaiusculaCadaPalavra(descricaoPrestador)}`;
      }

      return `${this.letraMaiusculaCadaPalavra(
        descricaoPrestador
      )}, ${this.$helpers.formatadorData(competencia, "MMMM [de] YYYY")}.`;
    }
  }
};
</script>

<style lang="scss" scoped>
.container-vertical {
  display: flex;
  justify-content: center;
}
</style>
